export default class StepInstructionRenderer {
  eGui

  init(params) {
    const divMain = document.createElement('div')
    if (params.data[params.colDef.field]) {
      if (params.data[params.colDef.field].isPassed) {
        divMain.style.color = 'green'
      }
      divMain.innerHTML = params.data[params.colDef.field].message
    }
    this.eGui = divMain
  }

  getGui() {
    return this.eGui
  }
}
